/*
  Winter Scent pill (was the Fall Scent pill, Asana 1219465269687306; swapped
  to Winter / Simple Fresh 11/02). Markup + styles live in
  snippets/bar-types-2026.liquid; shown to everyone on the Volumizing S&C set,
  shampoo bar and conditioner bar PDPs.

  Click Winter Scent -> pill active, own bar-type pill outlined, scent picker
  switched to Simple Fresh, gallery pill + swatch ring +
  "Winter pick" tag after the scent name on.
  Picking Simple Fresh from the swatches (or landing on it) turns it on too.
  Picking any other scent, or clicking the own bar-type pill, turns it off;
  the own-pill click also puts back the scent that was picked before Winter.
*/
(function () {
  var container = document.querySelector('.bar-types-container');
  var pill = container && container.querySelector('.winter-scent-pill');
  if (!pill) return;

  var scent = pill.dataset.winterScent;
  var ownPill = container.querySelector('[aria-current="true"]');
  var active = false;
  var previousScent = null;

  function radioFor(value) {
    var radios = document.querySelectorAll('variant-picker input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) return radios[i];
    }
    return null;
  }

  function checkedScent() {
    var checked = document.querySelector('variant-picker input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  // Non-bubbling change, so the document listener below ignores it
  function selectRadio(radio) {
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change'));
  }

  // variant-picker rewrites the scent label on every change, so the tag is
  // re-added after the switch and removed when Winter mode ends
  function setTag(on) {
    var title = document.querySelector('variant-picker .variant-picker__swatch-option__lable__title');
    if (!title) return;
    var tag = title.querySelector('.winter-scent-tag');
    if (on && !tag) {
      tag = document.createElement('span');
      tag.className = 'winter-scent-tag';
      tag.textContent = 'Winter pick';
      var name = title.firstElementChild;
      if (name) name.after(tag);
      else title.appendChild(tag);
    } else if (!on && tag) {
      tag.remove();
    }
  }

  // The selected pill is bold and the other one regular, so both get a min-width
  // at their bold size; otherwise the row shifts. The font has no real bold face,
  // and Safari's synthetic bold is wider (Chrome's is not). Measure with the
  // transition off: the pills have transition-all, so a width read right after
  // switching the weight returns the old, regular width.
  var widthsLocked = false;
  function lockWidths() {
    if (widthsLocked || !pill.getClientRects().length) return; // hidden: try again on click
    widthsLocked = true;
    [ownPill, pill].forEach(function (el) {
      if (!el) return;
      var transition = el.style.transition;
      var weight = el.style.fontWeight;
      el.style.transition = 'none';
      var width = el.getBoundingClientRect().width;
      el.style.fontWeight = '700';
      width = Math.max(width, el.getBoundingClientRect().width);
      el.style.fontWeight = weight;
      void el.offsetWidth;
      el.style.transition = transition;
      el.style.minWidth = width + 'px';
      // The Winter pill keeps its icon pinned left, so only the text side grows
      el.style.justifyContent = el === pill ? 'flex-start' : 'center';
    });
  }

  // Lock before the first click, once the fonts are in
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(lockWidths);
  else window.addEventListener('load', lockWidths);

  function galleryPills() {
    return document.querySelectorAll('.bar-type-pill');
  }

  function setActive(on) {
    if (on === active) return;
    active = on;
    container.classList.toggle('is-winter', on);
    document.body.classList.toggle('winter-scent-on', on);
    pill.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (ownPill) {
      if (on) ownPill.setAttribute('role', 'button');
      else ownPill.removeAttribute('role');
    }
    galleryPills().forEach(function (el) {
      var label = el.querySelector('span') || el;
      if (!el.dataset.winterOriginal) el.dataset.winterOriginal = label.textContent;
      label.textContent = on ? 'Winter Scent' : el.dataset.winterOriginal;
      el.classList.toggle('winter-scent-gallery-pill', on);
    });
  }

  pill.addEventListener('click', function () {
    var radio = radioFor(scent);
    if (!radio) return;
    if (!active) previousScent = checkedScent();
    lockWidths();
    setActive(true);
    selectRadio(radio);
    lastScent = scent;
    setTag(true);
  });

  // Scent to go back to: the one before Winter, else the first other scent
  function fallbackScent() {
    if (previousScent && previousScent !== scent) return previousScent;
    var radios = document.querySelectorAll('variant-picker input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value !== scent) return radios[i].value;
    }
    return null;
  }

  if (ownPill) {
    ownPill.addEventListener('click', function () {
      if (!active) return;
      var back = fallbackScent();
      setActive(false);
      setTag(false);
      selectRadio(radioFor(back));
      lastScent = back;
    });
  }

  // Real swatch clicks bubble (selectRadio's change does not): picking
  // Simple Fresh turns Winter on, picking anything else turns it off
  var lastScent = checkedScent();
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.matches || !target.matches('variant-picker input[type="radio"]')) return;
    if (target.value === scent) {
      if (!active) {
        previousScent = lastScent;
        lockWidths();
        setActive(true);
      }
      setTag(true);
    } else if (active) {
      setActive(false);
    }
    lastScent = target.value;
  });

  // Page opened on Simple Fresh (e.g. ?variant= link): show Winter as on
  if (lastScent === scent) {
    previousScent = null;
    setActive(true);
    setTag(true);
  }
})();
